// Generated by CoffeeScript 2.7.0
var InitialVertexConfig;

import VertexConfig from './base.js';

export default InitialVertexConfig = Vue.extend({
  extends: VertexConfig,
  template: `<div class="config-container">
  <tabs navsClass='nav secondary config-nav' v-if='configable'>
    <tab name='节点基础属性' tabKey='basic'>
      <div class="config-item">
        <div class="config-item-content">
          <div class="list settings-list">
            <div class="list-item">
              <div class="tip">节点名称</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.name' placeholder='节点名称' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <user-boundary-comp :userBoundary='vertex.user_boundary'
                          title='发起者范围'
                          @valueChanged='userBoundaryChangeFunc' />
      <user-boundary-comp :userBoundary='vertex.cc_user_boundary'
                          title='抄送'
                          @valueChanged='ccUserBoundaryChangeFunc' />
    </tab>
    <tab name='更多属性' tabKey='additional'>
      <div class="config-item">
        <div class="config-item-content">
          <div class="list settings-list">
            <div class="list-item">
              <div class="tip">电子签字</div>
              <div class="content">
                <label class="small switch">
                  <input type="checkbox" hidden='true' v-model='vertex.operations.esignature.enabled' />
                  <span></span>
                </label>
              </div>
            </div>
            <div class="list-item">
              <div class="tip">手动抄送</div>
              <div class="content">
                <label class="switch small">
                  <input type="checkbox" hidden='true' v-model='vertex.settings.carbon_copy.enable_manual' />
                  <span></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="config-item">
        <div class="config-item-title">操作者按钮</div>
        <div class="config-item-content">
          <div class="list operations-list">
            <operation-btn-checkbox :button='vertex.operations.propose'
                                    type='propose' />
            <label class="option-item">
              <input type="checkbox" :checked="initialSettingsAssignManual" @change='setAssignManually' hidden='true'>
              <i class="slp-square-o"></i>
              <div class="option-label">手动选择下一个处理者</div>
            </label>
            <div class="list-item" v-if="vertex.settings.assign_manually">
              <div class="tip">
                <div class="option-item">
                  <i class="slp-empty"></i>
                  <div class="option-label">方式</div>
                </div>
              </div>
              <div class="content">
                <dropdown-select :optionGroups="[{ options: allowedApproveValue }]"
                                customClass='transparent'
                                :initValue='vertex.settings.assign_manually'
                                @change='approveValueChangeFunc'>
                  <template slot='value-template' slot-scope='{ option }'>
                    <span>{{ Skylark.Helpers.getZH_CN('assignment.approve.' + option) }}</span>
                  </template>
                  <template slot='option-template' slot-scope='{ option }'>
                    <span>{{ Skylark.Helpers.getZH_CN('assignment.approve.' + option) }}</span>
                  </template>
                </dropdown-select>
              </div>
            </div>
            <operation-btn-checkbox :button='vertex.operations.stash'
                                    type='stash' />
            <operation-btn-checkbox :button='vertex.operations.cancel'
                                    type='cancel' />
            <operation-btn-checkbox :button='vertex.operations.remind'
                                    type='remind' />
            <operation-btn-checkbox :button='vertex.operations.repropose'
                                    type='repropose' />
          </div>
        </div>
      </div>
    </tab>
  </tabs>
  <template v-else>
    <div class="blankslate">
      <i class="slp-stop"></i>
      <p>该节点不能设置任何属性</p>
    </div>
  </template>
</div>`,
  computed: {
    configable: function() {
      return this.vertex.graph.isRootGraph();
    }
  }
});
